export const ENV = process.env.REACT_APP_Environment;
export const ROOT_URL = process.env.REACT_APP_API_BaseUrl;
export const API_STORAGE = process.env.REACT_APP_API_STORAGE;
export const CLIENT_REDIRECT_BASE = process.env.REACT_APP_Client_RedirectUrl;
export const NODE_ENV = process.env.NODE_ENV;
export const PUBLIC_URL = process.env.PUBLIC_URL;
export const IS_PROD = ENV === "production";
export const IS_STAGING = ENV === "staging";

export const API_BLOB_URL = process.env.REACT_APP_API_BlobUrl;
export const LORRI_APPLICATION_SERVICES = process.env.REACT_APP_LORRI_APPLICATION_SERVICES;
export const API_INTERNAL_API_URL = process.env.REACT_APP_API_InternalAPIURL;
export const APPLICATION_NAME = process.env.REACT_APP_APPLICATION_NAME;
export const ADB2C_CONFIG_TENANT_REDIRECT_URL = process.env.REACT_APP_Adb2cConfig_TenantRedirectUrl;
export const COMPANY_SIDE_URL = process.env.REACT_APP_CompanySideUrl;
export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
export const GOOGLE_ID = process.env.REACT_APP_GOOGLE_ID;
export const API_LOGO_BASE_URL = process.env.REACT_APP_API_LogoBaseUrl;
export const DECRYPTION_KEY_HEX = process.env.REACT_APP_DECRPTION_KEY_HEX;

export const FIREBASE_API_KEY = process.env.REACT_APP_ApiKey;
export const FIREBASE_AUTH_DOMAIN = process.env.REACT_APP_AuthDomain;
export const FIREBASE_PROJECT_ID = process.env.REACT_APP_ProjectId;
export const FIREBASE_STORAGE_BUCKET = process.env.REACT_APP_StorageBucket;
export const FIREBASE_MESSAGING_SENDER_ID = process.env.REACT_APP_MessagingSenderId;
export const FIREBASE_APP_ID = process.env.REACT_APP_AppId;
export const FIREBASE_MEASUREMENT_ID = process.env.REACT_APP_MeasurementId;

export const RTDB_API_KEY = process.env.REACT_APP_RTDB_API_KEY;
export const RTDB_AUTH_DOMAIN = process.env.REACT_APP_RTDB_AUTH_DOMAIN;
export const RTDB_API_KEY_DB_URL = process.env.REACT_APP_RTDB_API_KEY_DB_URL;
export const RTDB_API_KEY_PRODUCT_ID = process.env.REACT_APP_RTDB_API_KEY_PRODUCT_ID;
export const RTDB_API_KEY_STORAGE_BUCKET = process.env.REACT_APP_RTDB_API_KEY_STORAGE_BUCKET;
export const RTDB_API_KEY_SENDER_ID = process.env.REACT_APP_RTDB_API_KEY_SENDER_ID;
export const RTDB_API_KEY_APP_ID = process.env.REACT_APP_RTDB_API_KEY_APP_ID;
